import LiveDays from "./LiveDays";
import LiveFormules from "./LiveFormules";
import LivePosButton from "./LivePosButton";

const LiveSubmenu = () => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <LiveDays />
      <LiveFormules />
      <LivePosButton />
    </div>
  );
};

export default LiveSubmenu;
